import type { BoardStatePayload } from '@multirx/shared/types/board.js';

/**
 * Le premier `BOARD_EVENTS.STATE`/`WARMUP_START` arrive pendant que le lobby
 * est encore monté (avant la navigation vers `#plateau`) — sans ce petit
 * cache, `mountBoardView.ts` n'aurait rien à afficher tant qu'aucun nouvel
 * événement ne survient après son propre montage (le socket persiste entre
 * les vues SPA, mais un `on(...)` posé après coup rate ce qui a déjà été émis).
 */
let lastState: { sessionId: number; state: BoardStatePayload } | null = null;

export function setLastBoardState(sessionId: number, state: BoardStatePayload): void {
  lastState = { sessionId, state };
}

export function takeLastBoardState(sessionId: number): BoardStatePayload | null {
  if (!lastState || lastState.sessionId !== sessionId) return null;
  const { state } = lastState;
  lastState = null;
  return state;
}
